import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { startPageTranslator } from './i18n/pageTranslator'

// Load the chosen language first so returning visitors never see a flash of English.
void startPageTranslator().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
